<template>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 48 48"
	><path d="M10 38v-9.65h3V35h6.65v3Zm0-18.35V10h9.65v3H13v6.65ZM28.35 38v-3H35v-6.65h3V38ZM35 19.65V13h-6.65v-3H38v9.65Z" /></svg>
</template>
